import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const gpaCalculatorTool: Tool = {
  id: "gpa-calculator",
  name: () => m.gpa_tool_name(),
  description: () => m.gpa_tool_description(),
  icon: "🎓",
  basePath: "/gpa-calculator",
  status: "stable",
  tags: ["education", "school", "gpa", "gpa-calculator"],
};
